import { useMemo } from 'react';

import { collection, query, where, CollectionReference, Query, QueryConstraint } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import SupportAction from '../types/SupportAction';

interface UseSupportActionProps {
  personId: string | null;
}

export default function useSupportAction(props: UseSupportActionProps) {
  const { personId } = props;
  const { isGod } = useAuth();

  const supportActionQuery = useMemo(() => {
    if (!personId) return null;

    const conditions: QueryConstraint[] = [];

    if (!isGod) {
      conditions.push(where('isDeleted', '==', false));
    }

    conditions.push(where('personId', '==', personId));

    return query(
      collection(firestore, 'supportAction') as CollectionReference<SupportAction>,
      ...conditions
    ) as Query<SupportAction>;
  }, [personId, isGod]);

  const [supportActions, isSupportActionsLoading, supportActionsError] =
    useCollectionData<SupportAction>(supportActionQuery);

  return {
    supportActions: supportActions ?? [],
    isSupportActionsLoading,
    supportActionsError,
  };
}
